import addSFX1 from "./achive-sound-132273.mp3";
import haveSFX from "./beep-6-96243.mp3";
import addSFX2 from "./button-pressed-38129.mp3";
import buttonClickSFX2 from "./click-button-140881.mp3";
import CompletionSFX from "./click-game-menu-147356.mp3";
import menuOpenSFX from "./clickselect-92098.mp3";
import finishSFX from "./divinity-138419.mp3";
import emailSFX from "./e-mail-39993.mp3";
import clearSFX from "./error-2-126514.mp3";
import wrongFilterSFX2 from "./error-when-entering-the-game-menu-132111.mp3";
import resetOrClearFilterSFX from "./fantasy_ui_button_6-102219.mp3";
import listCloseOpenSFX from "./killswitch-being-turned-on-100591.mp3";
import linkClickSFX from "./light-switch-156813.mp3";
import typeSFX from "./mech-keyboard-02-102918.mp3";
import mouseClickSFX from "./mouse-click-153941.mp3";
import pencilCheckSFX from "./pencil_check_mark_1-88805.mp3";
import resetSFX from "./ping-82822.mp3";
import openListorClearSFX from "./projector-button-push-6258.mp3";
import writingSFX from "./scribbling-68130.mp3";
import addDeniedSFX from "./select_denied_03-45945.mp3";
import slideOutInSFX from "./sliding_wooden_cabinet_door_1-of-2-81503.mp3";
import openCloseAddFormSFX from "./spring-click-sound-95507.mp3";
import navLinkClickSFX from "./switch-light-04-82204.mp3";
import deleteSFX from "./toy-button-105724.mp3";
import correctOrAddSFX from "./ui_correct_button2-103167.mp3";
import menuButtonClick from "./ui-click-43196.mp3";
import editClickSFX from "./uiclick4-79818.mp3";
import toBottomTopSFX from "./uisound1-79819.mp3";
import wrongFilterSFX from "./wrong-answer-129254.mp3";
import slideOutSFX from "./door-open-107728.mp3";
// import buttonSFX from "./button-8-88355.mp3"; import buttonClickSFX from "./click-3-44710.mp3" import inputErrorSFX from "./error-call-to-attention-129258.mp3"; import switchSFX from "./switch-93378.mp3";

const COMMON_SFX_VOLUME = 0.4;
const addSFXAudio1 = new Audio(addSFX1);
addSFXAudio1.volume = COMMON_SFX_VOLUME;
const haveSFXAudio = new Audio(haveSFX);
haveSFXAudio.volume = COMMON_SFX_VOLUME;
const addSFXAudio2 = new Audio(addSFX2);
addSFXAudio2.volume = COMMON_SFX_VOLUME;
const buttonClickSFXAudio2 = new Audio(buttonClickSFX2);
buttonClickSFXAudio2.volume = COMMON_SFX_VOLUME;
const completionSFXAudio = new Audio(CompletionSFX);
completionSFXAudio.volume = COMMON_SFX_VOLUME;
const menuOpenSFXAudio = new Audio(menuOpenSFX);
menuOpenSFXAudio.volume = COMMON_SFX_VOLUME;
const finishSFXAudio = new Audio(finishSFX);
finishSFXAudio.volume = COMMON_SFX_VOLUME;
const linkClickSFXAudio = new Audio(linkClickSFX);
linkClickSFXAudio.volume = COMMON_SFX_VOLUME;
const listCloseOpenSFXAudio = new Audio(listCloseOpenSFX);
listCloseOpenSFXAudio.volume = COMMON_SFX_VOLUME;
const toBottomTopSFXAudio = new Audio(toBottomTopSFX);
toBottomTopSFXAudio.volume = COMMON_SFX_VOLUME;
const editClickSFXAudio = new Audio(editClickSFX);
editClickSFXAudio.volume = COMMON_SFX_VOLUME;
const menuButtonClickAudio = new Audio(menuButtonClick);
menuButtonClickAudio.volume = COMMON_SFX_VOLUME;
const deleteSFXAudio = new Audio(deleteSFX);
deleteSFXAudio.volume = COMMON_SFX_VOLUME;
const wrongFilterSFXAudio = new Audio(wrongFilterSFX);
wrongFilterSFXAudio.volume = COMMON_SFX_VOLUME;
const wrongFilterSFXAudio2 = new Audio(wrongFilterSFX2);
wrongFilterSFXAudio2.volume = COMMON_SFX_VOLUME;
const correctOrAddSFXAudio = new Audio(correctOrAddSFX);
correctOrAddSFXAudio.volume = COMMON_SFX_VOLUME;
const openCloseAddFormSFXAudio = new Audio(openCloseAddFormSFX);
openCloseAddFormSFXAudio.volume = COMMON_SFX_VOLUME;
const navLinkClickSFXAudio = new Audio(navLinkClickSFX);
navLinkClickSFXAudio.volume = COMMON_SFX_VOLUME;
const slideOutInSFXAudio = new Audio(slideOutInSFX);
slideOutInSFXAudio.volume = COMMON_SFX_VOLUME;
const clearSFXAudio = new Audio(clearSFX);
clearSFXAudio.volume = COMMON_SFX_VOLUME;
const addDeniedSFXAudio = new Audio(addDeniedSFX);
addDeniedSFXAudio.volume = COMMON_SFX_VOLUME;
const writingSFXAudio = new Audio(writingSFX);
writingSFXAudio.volume = COMMON_SFX_VOLUME;
const openListorClearSFXAudio = new Audio(openListorClearSFX);
openListorClearSFXAudio.volume = COMMON_SFX_VOLUME;
const typeSFXAudio = new Audio(typeSFX);
typeSFXAudio.volume = COMMON_SFX_VOLUME;
const resetSFXAudio = new Audio(resetSFX);
resetSFXAudio.volume = COMMON_SFX_VOLUME;
const pencilCheckSFXAudio = new Audio(pencilCheckSFX);
pencilCheckSFXAudio.volume = COMMON_SFX_VOLUME;
const mouseClickSFXAudio = new Audio(mouseClickSFX);
mouseClickSFXAudio.volume = COMMON_SFX_VOLUME;
const resetOrClearFilterSFXAudio = new Audio(resetOrClearFilterSFX);
resetOrClearFilterSFXAudio.volume = COMMON_SFX_VOLUME;
const emailSFXAudio = new Audio(emailSFX);
emailSFXAudio.volume = COMMON_SFX_VOLUME;
const slideOutSFXAudio = new Audio(slideOutSFX);
slideOutSFXAudio.volume = COMMON_SFX_VOLUME;
// const buttonSFXAudio = new Audio(buttonSFX); buttonSFXAudio.volume = COMMON_SFX_VOLUME; const buttonClickSFXAudio = new Audio(buttonClickSFX); buttonClickSFXAudio.volume = COMMON_SFX_VOLUME; const inputErrorSFXAudio = new Audio(inputErrorSFX); inputErrorSFXAudio.volume = COMMON_SFX_VOLUME; const switchSFXAudio = new Audio(switchSFX); switchSFXAudio.volume = COMMON_SFX_VOLUME;

const playSFXAudio = (...audios) => {
  try {
    audios.forEach((audio) => {
      audio.currentTime = 0;
      audio.readyState >= 1 && audio.play().catch(err => {console.log(err);});
    });
  } catch (error) {
    console.log(error);
  }
};

export {
  playSFXAudio,
  addSFXAudio1,
  haveSFXAudio,
  addSFXAudio2,
  buttonClickSFXAudio2,
  completionSFXAudio,
  menuOpenSFXAudio,
  finishSFXAudio,
  linkClickSFXAudio,
  listCloseOpenSFXAudio,
  toBottomTopSFXAudio,
  editClickSFXAudio,
  menuButtonClickAudio,
  deleteSFXAudio,
  wrongFilterSFXAudio,
  wrongFilterSFXAudio2,
  correctOrAddSFXAudio,
  openCloseAddFormSFX,
  openCloseAddFormSFXAudio,
  navLinkClickSFXAudio,
  slideOutInSFXAudio,
  clearSFXAudio,
  addDeniedSFXAudio,
  writingSFXAudio,
  openListorClearSFXAudio,
  typeSFXAudio,
  resetSFXAudio,
  pencilCheckSFXAudio,
  mouseClickSFXAudio,
  resetOrClearFilterSFXAudio,
  emailSFXAudio,
  slideOutSFXAudio,
  // buttonSFXAudio, buttonClickSFXAudio, inputErrorSFXAudio, switchSFXAudio,
};
